import { render, staticRenderFns } from "./lotIdInfo.vue?vue&type=template&id=52f1049c&scoped=true&"
import script from "./lotIdInfo.vue?vue&type=script&lang=js&"
export * from "./lotIdInfo.vue?vue&type=script&lang=js&"
import style0 from "./lotIdInfo.vue?vue&type=style&index=0&id=52f1049c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f1049c",
  null
  
)

export default component.exports